import { render, staticRenderFns } from "./SelectSharingPermissions.vue?vue&type=template&id=7a7be3e6&scoped=true"
import script from "./SelectSharingPermissions.vue?vue&type=script&lang=ts"
export * from "./SelectSharingPermissions.vue?vue&type=script&lang=ts"
import style0 from "./SelectSharingPermissions.vue?vue&type=style&index=0&id=7a7be3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7be3e6",
  null
  
)

export default component.exports